import { createSelector } from 'reselect'

export const getOffset = (state, props) => {
  return state.kanbo.env.timeOffset
}

export const makeTimeOffsetSelector = () => createSelector(
  [getOffset],
  (offset) => {
    return offset
  }
)

export const timeOffsetSelector = makeTimeOffsetSelector()
